import { http } from "./httpServices";

export function createPriceLookup(data: any) {
  return http.post("/price-lookup", data);
}

export function getPriceLookupList(params: any) {
  return http.get("/price-lookup/list", {
    params: {
      ...params,
    },
  });
}

export function updatePriceLookup(id: any, updatedData: any) {
  return http.put(`/price-lookup/${id}`, updatedData);
}

export function getPriceLookupById(id: any) {
  return http.get(`/price-lookup/${id}`);
}
